import { render, staticRenderFns } from "./PasswordChangerComponent.vue?vue&type=template&id=79a11c06"
import script from "./PasswordChangerComponent.vue?vue&type=script&lang=js"
export * from "./PasswordChangerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports